<template>
  <div style="height: 100%">
    <v-card class="shadow" style="height: 100%">
      <div class="d-flex justify-space-between align-center bs-py-3 bs-px-4">
        <h3>Daily Revenue</h3>
        <v-btn
          text
          class="text-uppercase px-4"
          @click="filterDialog = true"
          :disabled="revenueStatisticsLoading"
        >
          {{ revenueStatistics.label }}
        </v-btn>
      </div>
      <v-divider></v-divider>
      <div class="d-flex align-center justify-center pa-6">
        <div v-if="revenueStatisticsLoading" class="text-center" style="height: 100%">
          <div class="d-flex align-center" style="gap: 1rem">
            <v-progress-circular
              :size="20"
              :width="3"
              color="secondary"
              indeterminate
            ></v-progress-circular>
            <span>Fetching chart information</span>
          </div>
        </div>
        <div style="width: 100%" v-else>
          <LineChart :theChartData="revenueStatistics" style="margin-top: -15px" />
        </div>
      </div>
      <div v-if="!revenueStatisticsLoading">
        <v-divider></v-divider>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th></th>
                <th class="text-right grey--text">Average</th>
                <th class="text-right grey--text">Lowest</th>
                <th class="text-right grey--text">Highest</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span class="grey--text d-flex align-center"
                    ><i
                      class="fas fa-circle mr-4"
                      style="font-size: 6px; color: #ab47bc"
                    ></i>
                    Gross Sales</span
                  >
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(revenueStatistics.avgGrossSales)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && lowestGrossAmount
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(parseFloat(lowestGrossAmount))}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && highestGrossAmount
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(parseFloat(highestGrossAmount))}`
                        : "₱0"
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="grey--text d-flex align-center">
                    <i class="fas fa-circle mr-4" style="font-size: 6px; color: #ec407a">
                    </i
                    >Payouts
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(revenueStatistics.avgPayouts)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && lowestPayout
                        ? "₱" + `${moneyFormatHundredthsPlace(parseFloat(lowestPayout))}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && highestPayout
                        ? "₱" + `${moneyFormatHundredthsPlace(parseFloat(highestPayout))}`
                        : "₱0"
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="grey--text d-flex align-center">
                    <i
                      class="fas fa-circle mr-4"
                      style="font-size: 6px; color: #ffa726"
                    ></i
                    >GGR
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(revenueStatistics.avgGGR)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && lowestGrossGamingRevenue
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(lowestGrossGamingRevenue)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && highestGrossGamingRevenue
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(highestGrossGamingRevenue)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="grey--text d-flex align-center">
                    <i
                      class="fas fa-circle mr-4"
                      style="font-size: 6px; color: #5c6bc0"
                    ></i
                    >PAGCOR Share
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(revenueStatistics.avgPagcorShare)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && lowestPagcorShare
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(parseFloat(lowestPagcorShare))}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && highestPagcorShare
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(parseFloat(highestPagcorShare))}`
                        : "₱0"
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="grey--text d-flex align-center">
                    <i
                      class="fas fa-circle mr-4"
                      style="font-size: 6px; color: #81c784"
                    ></i
                    >Net Amount
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(
                            parseFloat(revenueStatistics.avgNetAmount)
                          )}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && lowestNetAmount
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(parseFloat(lowestNetAmount))}`
                        : "₱0"
                    }}
                  </span>
                </td>
                <td class="text-right">
                  <span>
                    {{
                      revenueStatistics && highestNetAmount
                        ? "₱" +
                          `${moneyFormatHundredthsPlace(parseFloat(highestNetAmount))}`
                        : "₱0"
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>

    <v-dialog
      ref="filterDialog"
      v-model="filterDialog"
      :return-value.sync="month"
      persistent
      width="290px"
    >
      <v-date-picker v-model="month" full-width type="month">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancelFilter"> Cancel </v-btn>
        <v-btn text color="primary" @click="saveFilter"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import formatDatev2 from "@/helpers/formatDatev2";
import LineChart from "@/components/dashboard/monthrevenuestatistics/LineChart.vue";
import GetPercentage from "@/helpers/getPercentage";

export default {
  components: { LineChart },
  data: () => ({
    month: formatDatev2(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      "format",
      "yyyy-MM"
    ),
    filterDialog: false,
  }),
  props: {
    game_id: Number,
  },
  computed: {
    ...mapState(["accountInfo"]),
    ...mapState("dashboard", ["revenueStatistics", "revenueStatisticsLoading"]),

    totalGrossAmount() {
      if (this.revenueStatistics.grossAmounts) {
        const arr = this.revenueStatistics.grossAmounts;
        return arr.reduce((a, b) => a + b, 0);
      }
      return 0;
    },

    highestGrossAmount() {
      if (this.revenueStatistics.grossAmounts) {
        const arr = this.revenueStatistics.grossAmounts;
        return Math.max(...arr);
      }
      return 0;
    },

    highestPayout() {
      if (this.revenueStatistics.distributedPrizes) {
        const arr = this.revenueStatistics.distributedPrizes;
        return Math.max(...arr);
      }
      return 0;
    },

    highestGrossGamingRevenue() {
      if (this.revenueStatistics.netAmount) {
        const arr = this.revenueStatistics.netAmount;
        return Math.max(...arr);
      }
      return 0;
    },

    highestPagcorShare() {
      if (this.revenueStatistics.pagcorShare) {
        const arr = this.revenueStatistics.pagcorShare;
        return Math.max(...arr);
      }
      return 0;
    },

    highestNetAmount() {
      if (this.revenueStatistics.netIncome) {
        const arr = this.revenueStatistics.netIncome;
        return Math.max(...arr);
      }
      return 0;
    },

    lowestGrossAmount() {
      if (this.revenueStatistics.grossAmounts) {
        // const arr = this.revenueStatistics.grossAmounts;
        // const labels = this.revenueStatistics.labels;

        // const merged = [];

        // for (let i = 0; i < arr.length; i++) {
        //   merged.push({ gross_amount: arr[i], day: labels[i] });
        // }

        // const filtered_array = arr.filter((val) => val != 0);
        // if (filtered_array.length != 0) return Math.min(...filtered_array);

        const arr = this.revenueStatistics.grossAmounts;
        const filtered_array = arr.filter((val) => val != 0);
        if (filtered_array.length != 0) return Math.min(...filtered_array);
      }
      return 0;
    },

    lowestPayout() {
      if (this.revenueStatistics.distributedPrizes) {
        const arr = this.revenueStatistics.distributedPrizes;
        const filtered_array = arr.filter((val) => val != 0);
        if (filtered_array.length != 0) return Math.min(...filtered_array);
      }
      return 0;
    },

    lowestGrossGamingRevenue() {
      if (this.revenueStatistics.netAmount) {
        const arr = this.revenueStatistics.netAmount;
        const filtered_array = arr.filter((val) => val != 0);
        if (filtered_array.length != 0) return Math.min(...filtered_array);
      }
      return 0;
    },

    lowestPagcorShare() {
      if (this.revenueStatistics.pagcorShare) {
        const arr = this.revenueStatistics.pagcorShare;
        const filtered_array = arr.filter((val) => val != 0);
        if (filtered_array.length != 0) return Math.min(...filtered_array);
      }
      return 0;
    },

    lowestNetAmount() {
      if (this.revenueStatistics.netIncome) {
        const arr = this.revenueStatistics.netIncome;
        const filtered_array = arr.filter((val) => val != 0);
        if (filtered_array.length != 0) return Math.min(...filtered_array);
      }
      return 0;
    },
  },
  mounted() {
    if (this.accountInfo.access.includes(21)) {
      this.doGetData();
    }
  },
  methods: {
    ...mapActions("dashboard", ["getRevenueStatistics"]),
    cancelFilter() {
      this.filterDialog = false;
    },
    saveFilter() {
      this.$refs.filterDialog.save(this.month);
      this.doGetData();
    },
    moneyFormat(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    moneyFormatHundredthsPlace(val) {
      return val.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    setPercentage(val, dividend) {
      if (val != 0 && dividend != 0) {
        return GetPercentage(val, dividend);
      } else {
        return 0;
      }
    },
    async doGetData() {
      if (!this.revenueStatisticsLoading) {
        this.$store.commit("dashboard/setRevenueStatistics", []);

        const formData = new FormData();
        formData.append("type", "Days");
        formData.append("val", this.month);
        formData.append("game_id", this.game_id);

        const getData = new URLSearchParams(formData);

        await this.getRevenueStatistics(getData);
      }
    },
  },
  watch: {
    game_id() {
      if (this.accountInfo.access.includes(21)) {
        this.doGetData();
      }
    },
  },
};
</script>
